Array.prototype.indexOfRootProp = function (key, value) {
  for (let i = 0; i < this.length; i++) {
    let item = this[i];
    if (item[key] === value) {
      return i;
    }
    return -1;
  }
};

Array.prototype.swap = function (x, y) {
  const b = this[x];
  this[x] = this[y];
  this[y] = b;
  return this;
};
